//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
import "../no/ErrorList.js";
let d=[[],[[["objects"],"AutoAssignAttributes",{R_:{failedObjectsErrorInfo:"ErrorList"}},1,0],[["objects","properties"],"AutoAssignAttributesWithNamingPattern",{R_:{failedObjectsErrorInfo:"ErrorList"}},2,0],[["attributeTitles","titlePatterns"],"CreateAttributeTitleToNamingPatternMap",{R_:{attributeTitleToNamingPatternMap:"NXObject"}},2,0],[["object","nRevsOpt","revOptions"],"GetItemRevisionNamingRules",{},1,0],[["object","nPatterns","patternList"],"GetItemNamingRulePatterns",{},1,0]],[]];
SPLM.Gateway.IGenericFileNewApplicationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.IGenericFileNewApplicationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;